export const PARTNER_LANGUAGE = {
  partner_add_information: "Information",
  partner_add_company_name: "Partner name",
  partner_add_company_name_msg: "Partner name is required",
  partner_add_company_name_space_error: "Name is invalid",
  partner_add_company_address_space_error: "Address is invalid",
  partner_add_company_name_limit: "Character must be smaller then 50",
  partner_add_contact_label: "Contact Number",
  partner_add_company_email_label: "Email Address",
  partner_add_company_email_error: "Email Address is required",
  partner_add_company_email_validation_length: "Email cannot be exceed 50 characters",
  partner_add_company_email_validation: "Invalid Email Address",
  partner_add_company_address_label: "Address",
  partner_add_company_address_error: "Address is required",
  partner_add_company_address_validation: "Character must be smaller then 250",
  partner_add_company_city_label: "City",
  partner_add_company_city_error: "City is required",
  partner_add_company_state_label: "Company State",
  partner_add_company_state_error: "Company State is required",
  partner_add_country_label: "Company Country",
  partner_add_country_error: "Company Country is required",
  partner_add_incentive_modes: "Incentive Modes",
  partner_add_incentive_modes_error: "Incentive Modes is required",
  partner_add_line_of_business: "Line Of Business",
  partner_add_line_of_business_error: "Line of business is required",
  partner_view_name: "Partner Name",

  partner_premises_listing_premises_name: "Name",
  partner_premises_listing_premises_contact_number: "Contact Number",
  partner_premises_listing_premises_email_address: "Email Address",
  partner_premises_listing_premises_city: "City",
  partner_premises_listing_premises_region: "Region",

  partner_premises_add_Premises: "Add Premises",
  partner_premises_edit_Premises: "Edit Premises",
  partner_premises_upload_documents: "Documents",
  partner_premises_add_name: "Name",
  partner_premises_add_name_msg: "Premises name is required",
  partner_premises_add_name_space_error: "Name is invalid",
  partner_premises_add_name_limit: "Character must be smaller then 50",
  partner_premises_add_contact_label: "Contact Number",
  partner_premises_add_contact_required: "Contact Number is required",
  partner_premises_add_contact_limit: "Character must be smaller then 13",
  partner_premises_add_email_label: "Email Address",
  partner_premises_add_email_error: "Email Address is required",
  partner_premises_add_email_validation_length: "Email cannot be exceed 50 characters",
  partner_premises_add_email_validation: "Invalid Email Address",
  partner_premises_add_city_label: "City",
  partner_premises_add_city_error: "City is required",
  partner_premises_add_region_label: "Region",
  partner_premises_view_name: "Premises Name",
  partner_premises_incentive_share: "Incentive Share",
  partner_premises_incentive_share_required_error: "Incentive Share is required",
  partner_premises_incentive_share_negative_error: "Negative value not allowed",
  partner_premises_incentive_share_max_error: "Max allowed value is 100",
  partner_premises_incentive_share_max_digit_error: "Max 3 digit allowed i.e. 100",
  partner_premises_incentive_share_max_decimal_error: "Max 3 decimal points allowed",
  partner_premises_point_share: "Points Share",
  partner_premises_point_share_required_error: "Point Share is required",
  partner_premises_point_share_negative_error: "Negative value not allowed",
  partner_premises_point_share_max_error: "Max allowed value is 100",
  partner_premises_point_share_max_digit_error: "Max 3 digit allowed i.e. 100",
  partner_premises_point_share_max_decimal_error: "Max 3 decimal points allowed",

  partner_premises_withholding_tax: "Withholding Tax",
  partner_premises_withholding_tax_required_error: "Withholding Tax is required",
  partner_premises_withholding_tax_negative_error: "Negative value not allowed",
  partner_premises_withholding_tax_max_error: "Max allowed value is 100",
  partner_premises_withholding_tax_max_digit_error: "Max 3 digit allowed i.e. 100",
  partner_premises_withholding_tax_max_decimal_error: "Max 3 decimal points allowed",

  partner_premises_import_premises: "Import Premises",
  partner_premises_import_premises_document_error_found: " errors have been found.",
  partner_premises_import_premises_document_click_here: " Click Here ",
  partner_premises_import_premises_document_error_download_file: " to Download the file.",
  partner_premises_import_premises_document_required_error: "Import document is required",
  partner_premises_upload_success_msg: "Upload Successful",
  partner_premises_view_action_bar_search: "Search",
  partner_premises_import_file_type_place_holder: "Format: xls, xlsx | Size: 15mb",
  partner_contact_title: "Point Of Contact",
  partner_contact_add_poc: "Add",
  partner_contact_add_line_of_business: "Line of Business",
  partner_contact_add_name: "Name",
  partner_contact_add_name_error: "Name is required",
  partner_contact_add_name_length_error: "Name must be lesser than 50 characters",
  partner_contact_add_number: "Contact Number",
  partner_contact_add_contact_error: "Contact Number is required",
  partner_contact_add_email: "Email Address",
  partner_contact_add_invalid_email_error: "Invalid email",
  partner_contact_add_email_error: "Email is required",
  partner_contact_add_designation: "Designation",
  partner_contact_add_city: "City",
  partner_contact_add_designation_error: "Designation is required",
  partner_contact_add_designation_character_error: "Designation must be lesser than 50 characters",
  partner_contact_add_city_error: "City is required",
  partner_contact_add_line_of_business_error: "Line of business is required",
  partner_contact_top_bar_search: "Search",
  partner_contact_add_title: "Point of Contact",
  partner_contact_edit_title: "Edit Point of Contact",
  partner_rate_setup: "Rate Setup",
  partner_label_brand_royalty: "Brand Royalty",
  partner_label_brand_royalty_required_error: "Brand Royalty is required",
  partner_label_brand_royalty_length_error:
    "Brand Royalty can never be negative and it can never be greater then 100 and it does not contain more than three decimal value",
  partner_label_point_amount_length_error:
    "Point Amount must contain up to five positive decimal value and does not contain more than two decimal value",
  partner_add_point_amount_type_id_required: "Point Amount type is required",
  partner_label_point_amount: "Point Amount",
  partner_label_point_amount_required_error: "Point Amount is required",

  partner_label_point_amount_type: "Point Amount Type",
  partner_label_point_amount_type_required_error: "Point Amount Type is required",

  partner_label_dealer_rate_range: "Dealer Rate Range",
  partner_label_dealer_rate_range_min: "Dealer Rate Range Min",
  partner_label_dealer_rate_range_min_required_error: "Range Min range is required",
  partner_label_dealer_rate_range_max_required_error: "Range Max range is required",

  partner_label_dealer_rate_range_max: "Dealer Rate Range Max",
  partner_label_dealer_rate_range_label: "Dealer Rate (Range)",
  partner_label_dealer_rate_range_required_error: "Dealer Rate Range is required",

  partner_label_dealer_rate_increment: "Dealer Rate Increment",
  partner_label_dealer_rate_increment_required_error: "Dealer Rate Increment is required",
  partner_label_dealer_rate_increment_length_number: "Dealer Rate can't be greater than max dealer rate",

  partner_label_withholding_tax: "Withholding Tax",
  partner_label_withholding_tax_required_error: "Withholding Tax is required",
  partner_label_withholding_tax_length_number: "Withholding Tax can't be greater than 100",

  partner_label_agent_service_charges: "Agent Service Charges",
  partner_label_agent_service_charges_required_error: "Agent Service Charges is required",
  partner_label_agent_service_charges_length_number: "Agent Service Charges can't be greater than 100",

  partner_label_agent_service_charges_withholding_tax: "Agent Service Charges WHT",
  partner_label_agent_service_charges_withholding_tax_required_error: "Agent Service Charges WHT is required",
  partner_label_agent_service_charges_withholding_tax_length_number: "Agent Service Charges WHT can't be greater than 100",

  partner_point_setup: "Point Setup",
  partner_point_range: "Point Range",
  partner_reward_points: "Reward Points",
  partner_required_error: "This is required",
  partner_point_setup_number_and_float_validation: "It must be number and contains only 3 decimal points",
  partner_point_setup_number_and_4_float_validation: "It must be number and contains only 3 decimal points",
  point_range_column: "Point Range",
  reward_points_column: "Reward Points",
  reward_points_column_required_error: "Reward Points is required",
  reward_points_column_length_error: "Reward Points must contain up to 4 digits and only up to 4 decimals",

  point_range_max_error_message: "Point range max must be greater than point range min",
  point_range_min_error_message: "Point range min must be less than point range max",
  point_range_min_max_range_conflict_error: "Range conflict",

  partner_user_info_title: "Information",

  partner_user_request_status_approve: "Approve",
  partner_user_request_status_reject: "Reject",
  partner_user_title: "Partner User",
  partner_user_add_create_user: "Create User",
  partner_user_list_partner: "Partner",
  partner_user_list_premises: "Premises",
  partner_user_list_contact_number: "Contact Number",
  partner_user_users_title: "Users",
  partner_user_request_title: "Requests",
  partner_user_reject_title: "Rejected",
  partner_user_add_partner_name: "Partner Name",
  partner_user_add_partner_name_required_error: "Partner Name is required",
  partner_user_add_premises_name: "Premises Name",
  partner_user_add_premises_name_required_error: "Premises Name is required",
  partner_user_add_filer_non_filer: "Filer / Non-Filer",
  partner_user_add_filer_filer_non_filer_error: "Filer / Non-Filer is required",
  partner_user_add_roles_error: "Role is required",
  partner_user_add_roles_title: "Roles",
  partner_user_add_filer: "Filer",
  partner_user_add_non_filer: "Non Filer",
  partner_user_add_request_status: "Request Status",
  partner_user_add_request_status_required_error: "Request Status is required",

  partner_b2c_user_list_b2b_partner: "B2B Partner",
  partner_b2c_user_list_b2b_organization_name: "B2B Organization Name",
  partner_b2c_user_list_b2b_organization_error: "B2B organization name is required",
  partner_b2c_user_add_roles_error: "Role is required",
  partner_b2c_user_add_roles_title: "Roles",

  partner_member_duplicate_error: "duplicate record",

  partner_incentive_management_encash: "Encash",
  partner_incentive_management_title: "Incentive Management",
  partner_incentive_management_partner: "Partner",
  partner_incentive_management_premises: "Premises",
  partner_incentive_management_listing_title: "Incentive Information",
  partner_incentive_management_listing_description: "Description",
  partner_incentive_management_listing_points: "Points",
  partner_incentive_management_listing_incentive_amount: "Incentive Amount",
  partner_incentive_management_listing_incentive_total_till_date: "Total Till Date",
  partner_incentive_management_listing_incentive_encashed_till_date: "Encashed Till Date",
  partner_incentive_management_listing_incentive_available_till_date: "Available Till Date",
  partner_incentive_management_request_enter_points: "Enter Points",
  partner_incentive_management_request_points_required_error: "Points is required",
  partner_incentive_management_request_points_max_length_error: "Points can have max 8 digits",
  partner_incentive_management_request_points_decimal_error: "Points can not have more than 2 decimal points",
  partner_incentive_management_request_enter_commission: "Enter Commission",
  partner_incentive_management_request_incentive_mode: "Incentive Mode",
  partner_incentive_management_request_incentive_mode_required_error: "Incentive Mode is required",
  partner_incentive_management_request_commission_required_error: "Commission is required",
  partner_incentive_management_request_commission_max_length_error: "Commission can have max 8 digits",
  partner_incentive_management_request_commission_decimal_error: "Commission can not have decimal points",
  partner_incentive_management_request_points_pts: "PTS",
  partner_incentive_management_request_commission_rs: "Rs",

  partner_incentive_requests_title: "Requests",
  partner_incentive_request_accepted_title: "Accepted",
  partner_incentive_request_rejected_title: "Rejected",
  partner_incentive_encashment_request_title: "Encashment Request",
  partner_incentive_encashment_request_partner_premises_list: "Premises",
  partner_incentive_encashment_request_listing_partner_name: "Partner Name",
  partner_incentive_encashment_request_listing_premises_name: "Premises Name",
  partner_incentive_encashment_request_listing_request_date: "Request Date",

  partner_incentive_encashment_approved_request_listing_partner_name: "Partner Name",
  partner_incentive_encashment_approved_request_listing_premises_name: "Premises Name",
  partner_incentive_encashment_approved_request_listing_request_date: "Request Date",
  partner_incentive_encashment_approved_request_listing_approved_date: "Approved Date",
  partner_incentive_encashment_approved_request_listing_encashment_amount: "Encashment Amount (Rs)",

  partner_incentive_encashment_rejected_request_listing_partner_name: "Partner Name",
  partner_incentive_encashment_rejected_request_listing_premises_name: "Premises Name",
  partner_incentive_encashment_rejected_request_listing_request_date: "Request Date",
  partner_incentive_encashment_rejected_request_listing_rejected_date: "Rejected Date",
  partner_incentive_encashment_rejected_request_listing_encashment_amount: "Encashment Amount (Rs)",
  partner_incentive_encashment_approved_request_view_title: "View Request",
  partner_incentive_encashment_approved_request_view_points_label: "Points",
  partner_incentive_encashment_approved_request_view_commission_label: "Commission",
  partner_incentive_encashment_approved_request_view_points_subtitle: "Points Converted Amount (Rs):",
  partner_incentive_encashment_approved_request_view_total_amount: "Total Amount (Rs) : ",
  partner_incentive_encashment_approved_request_view_mode_of_payment: "Mode Of Payment:",
  partner_incentive_encashment_approved_request_view_cheque_label: "Cheque",
  partner_incentive_encashment_approved_request_view_mode_of_payment_required: "Mode of payment is required",
  partner_incentive_encashment_approved_request_view_online_label: "Online Payment",
  partner_incentive_encashment_approved_request_view_transaction_id: "Transaction ID",
  partner_incentive_encashment_approved_request_view_transaction_id_required: "Transaction ID is required",
  partner_incentive_encashment_approved_request_view_transaction_id_length_error: "Transaction ID must not be greater than 50 characters",
  partner_incentive_encashment_approved_request_view_upload_label: "Upload Document",
  partner_incentive_encashment_approved_request_view_upload_button_label: "Upload",
  partner_incentive_encashment_approved_request_view_transaction_id_format_error: "Transaction ID must be alpha numeric",

  partner_incentive_encashment_approved_request_view_approve: "Approve",
  partner_incentive_encashment_approved_request_view_reject: "Reject",
  partner_incentive_encashment_approved_request_view_upload_required: "Cheque Image is required"
};
